export const SLogoImage = {
  height: 42,
  width: 42,
  maxHeight: { xs: 42, md: 42 },
  maxWidth: { xs: 42, md: 42 },
};
